





























































import Vue, { PropType } from 'vue';
import FileUploadMixin from '@/components/mixins/FileUploadMixin.vue';

export interface FormDataInterface {
  title?: string;
  description?: string;
  strength?: number;
}

export default Vue.extend({
  mixins: [FileUploadMixin],
  props: {
    sectionItem: {
      // FIXME update generated format
      // type: Object as () => CvSectionSkillItem,
      type: Object as PropType<any>,
      required: true,
    },
    isDeletable: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    const { title, description, strength } = this.sectionItem;
    return {
      formData: {
        title,
        description: description || '',
        strength,
      } as FormDataInterface,
    };
  },
  methods: {
    onSubmit() {
      this.$emit('submit', this.formData);
    },
    onCancel() {
      this.$emit('cancel');
    },
    onDelete() {
      this.$emit('delete');
    },
  },
});
